import styled from 'styled-components';
export const StyledLabel = styled.label<{
  notMarginBottom?: boolean;
  color?: string;
}>`
  text-align: justify;
  font-size: 14px;
  color: ${({ theme, color }) => color || theme.colors.gray600};
  font-weight: 700;
  margin-bottom: ${({ notMarginBottom }) => !notMarginBottom && '0.1rem'};
  margin-right: 12.5px;
`;
